<template>
  <v-container>
    <v-card class="text-center px-5 pb-5"
      ><v-card-text>
        <div
          class="text-h5 font-weight-medium text--primary"
          style="opacity: 0.8"
        >
          Übung hinzufügen
        </div>
      </v-card-text>
      <v-divider class="divider"></v-divider>
      <v-row v-if="newExerciseMessage.value">
        <v-col class="py-0">
          <v-alert type="alert" dense class="text-caption">
            {{ newExerciseMessage.value }}
          </v-alert>
        </v-col>
      </v-row>
      <v-form>
        <v-container>
          <v-row>
            <v-col class="py-1">
              <v-text-field
                outlined
                :value="newSlug"
                v-model="newSlug"
                label="Slug*"
                color="tertiary"
                hint="z.B. problem1, problem_1, problem-1"
                :rules="slugRules"
                persistent-hint
                required
              ></v-text-field>
            </v-col>
            <v-col class="py-1">
              <v-select
                outlined
                :value="newChapter"
                v-model="newChapter"
                color="tertiary"
                label="Kapitel*"
                :items="chapterItems"
                :rules="rules"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-text-field
                outlined
                :value="newProblemTitle"
                v-model="newProblemTitle"
                label="Problem Titel*"
                color="tertiary"
                :rules="rules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="text-justify">
            <v-col>
              <codemirror
                v-model="newProblem"
                :options="cmOptions"
                class="code-editor"
              ></codemirror>
            </v-col>
          </v-row>
          <v-row class="text-justify">
            <v-col>
              <codemirror
                v-model="newSubproblems"
                :options="cmOptions"
                class="code-editor"
              ></codemirror>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                :loading="loading"
                :disabled="loading"
                block
                depressed
                color="tertiary"
                class="white--text"
                @click="
                  {
                    loader = 'loading';
                    addExercise();
                  }
                "
                >Hinzufügen</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { useUserServiceInject } from "@/context";
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";

export default {
  name: "CreateExerciseView",
  setup() {
    const { isTutor, isStaff } = useUserServiceInject();
    return { isTutor, isStaff };
  },
  components: {
    codemirror,
  },
  data() {
    return {
      valid: false,
      chapters: null,
      exercises: null,
      rules: [(v) => !!v || "Dieses Feld darf nicht leer sein."],
      slugRules: [
        (v) =>
          /^[a-z\d\-_0-9]*$/.test(v) ||
          "Es sind nur a-z, 0-9, Binde- und Unterstrich erlaubt.",
        (v) => !!v || "Dieses Feld darf nicht leer sein.",
        (v) => !this.doesSlugExist(v) || "Dieser Slug existiert bereits.",
      ],
      subproblemRules: [],
      newSlug: null,
      newChapter: null,
      newProblemTitle: null,
      newProblem:
        "% Hier kannst du deinen LaTex-Code für das Problem hinzufügen\n",
      newSubproblems:
        "% Hier kannst du deinen LaTex-Code für die Subprobleme hinzufügen\n",
      newExerciseMessage: {
        type: "alert",
        value: null,
      },
      loading: false,
      loader: null,
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: "text/html",
        lineNumbers: true,
        line: true,
      },
    };
  },
  computed: {
    chapterItems() {
      if (this.chapters) {
        return this.chapters.map((c) => {
          return { text: c.title, value: c.id };
        });
      } else {
        return [];
      }
    },
    existingSlugs() {
      if (!this.exercises) return [];
      return this.exercises.map((e) => e.title);
    },
  },
  methods: {
    addExercise: function () {
      if (!this.isStaff) {
        this.newExerciseMessage.value =
          "Nur die Übungsleitung kann Übungen erstellen.";
        this.newExerciseMessage.type = "alert";
        return;
      }
      if (this.existingSlugs.includes(this.newSlug)) {
        this.newExerciseMessage.value =
          "Dieser Slug existiert bereits. Bitte wählen Sie einen anderen.";
        this.newExerciseMessage.type = "alert";
        return;
      }
      if (
        !this.newSlug ||
        !this.newChapter ||
        !this.newProblemTitle ||
        !this.newProblem
      ) {
        this.newExerciseMessage.value =
          "Bitte füllen Sie alle erforderlichen Felder aus.";
        this.newExerciseMessage.type = "alert";
        return;
      }
      const newExercise = {
        title: this.newSlug,
        chapter: this.newChapter,
        problemTitle: this.newProblemTitle,
        problem: this.newProblem,
        subproblems: this.newSubproblems,
        creator: this.getCreator(),
      };
      this.$axios.post("exercises", newExercise).then(() => {
        this.$router.push({ name: "exercises" }).catch(() => {
          this.newExerciseMessage.value = "Es ist ein Fehler aufgetreten.";
          this.newExerciseMessage.type = "alert";
          this.loader = null;
          this.loading = false;
          return;
        });
      });
    },
    getCreator() {
      if (this.isTutor || this.isStaff) {
        return "Tutor";
      } else {
        return "Student";
      }
    },
    doesSlugExist(s) {
      return this.existingSlugs.includes(s);
    },
  },
  created() {
    if (!this.isStaff) {
      this.$router.push({ name: "exercises" });
    }
    this.$axios
      .get("chapters")
      .then((response) => (this.chapters = response.data));
    this.$axios
      .get("exercises")
      .then((response) => (this.exercises = response.data));
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 20000);

      this.loader = null;
    },
  },
};
</script>

<style>
button {
  background-color: transparent !important;
}

textarea {
  border: none !important;
}

.CodeMirror {
  border-radius: 4px !important;
}
</style>

<style scoped>
.divider {
  margin-top: 0;
}

.code-editor {
  border: 1px solid;
  color: rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  width: 100%;
}
</style>
